import { Tab } from '@/types/tab';
import { TabServiceMock } from './mock/tabServiceMock';

export const tabDatabase: {[key: string]: Tab} = {
    '/api/tabs/1': {
        key: '/api/tabs/1',
        name: 'Tab1',
        successor: '/api/tabs/2',
    },
    '/api/tabs/2': {
        key: '/api/tabs/2',
        name: 'Tab2',
        successor: '/api/tabs/3',
    },
    '/api/tabs/3': {
        key: '/api/tabs/3',
        name: 'Tab3',
    },
};

export interface ITabService {
    getTab(key: string): Promise<Tab|null>;
}

export const TabService: ITabService = {

    async getTab(key: string): Promise<Tab|null> {
        if (tabDatabase[key] === undefined)
            return null;

        return tabDatabase[key];
    },

};

export function getTabService(): ITabService {
    return TabServiceMock;
}